<template>
  <!-- 组装拆分模板详情（新增/编辑） -->
  <div class="make-up-template-detail">
    <list-page>
      <list-table class="list-table" background-color="#FFF">
        <form-tag label="模板信息"/>
        <form-items :columns="2" :data="dataDetail">
          <form-item label="模板名称" :required="true" name="templateName" error-message="请输入模板名称">
            <el-input v-model="dataDetail.templateName" placeholder="如：电脑主机组装模板"/>
          </form-item>
          <form-item label="状态">
            <el-select v-model="dataDetail.status">
              <el-option label="启用" :value="1"/>
              <el-option label="停用" :value="0"/>
            </el-select>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input type="textarea" v-model="dataDetail.remark" placeholder="模板说明"/>
          </form-item>
        </form-items>

        <form-tag label="出库商品明细（组装时这些商品出库）"/>
        <product-select-table ref="outTable" v-model="dataDetail.outItems" :multi="true" height="auto" @table-select-multi="addList2Out">
          <yq-table-column label="数量" prop="qty" width="140rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.qty" :min="1" controls-position="right" style="width:100%"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位" prop="uniIdBase" width="120rem">
            <template v-slot="{row}">{{getUnitName(row.unitIdBase)}}</template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" align="center" width="90rem">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteOutItem($index)">删除</table-button>
            </template>
          </yq-table-column>
        </product-select-table>
        <div class="add-item-btn" @click="addOutItem">
          <yq-icon name="element-ui_plus"/>添加出库明细
        </div>

        <form-tag label="入库商品明细（组装时这些商品入库）"/>
        <product-select-table ref="inTable" v-model="dataDetail.inItems" :multi="true" height="auto" @table-select-multi="addList2In">
          <yq-table-column label="数量" prop="qty" width="140rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.qty" :min="1" controls-position="right" style="width:100%"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位" prop="uniIdBase" width="120rem">
            <template v-slot="{row}">{{getUnitName(row.unitIdBase)}}</template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" align="center" width="90rem">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteInItem($index)">删除</table-button>
            </template>
          </yq-table-column>
        </product-select-table>
        <div class="add-item-btn" @click="addInItem">
          <yq-icon name="element-ui_plus"/>添加入库明细
        </div>

        <div class="tip-info">
          💡 模板不区分「组装/拆分」：出库商品 × n → 入库商品 × m。拆分场景将出入库明细对调即可。
        </div>
      </list-table>

      <form-page :show-page="false">
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqIcon from "@/components/YqIcon.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import assemblyTemplateApi from "@/api/normal/stock/assemblyTemplateApi";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MakeUpTemplateDetail",
  components: {
    YqIcon, ProductSelectTable, YqTableColumn, TableButton, FormItems, FormItem, FormTag,
    PageButton, ListPage, ListTable, FormPage
  },
  data() {
    return {
      dataDetail: {},
      unitList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    let id = this.route.query.id;
    if (id) {
      this.findById(id);
    } else {
      this.initNew();
    }
    commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(units => this.unitList = units || []);
  },
  methods: {
    getUnitName(unitId) {
      return this.unitList.find(it => it.dictCode === unitId)?.dictName || "";
    },
    async findById(id) {
      const res = await assemblyTemplateApi.findById(id);
      // 回显时按 direction 拆分 出库(direction=1) / 入库(direction=2)
      this.dataDetail = res;
      this.dataDetail.outItems = [];
      this.dataDetail.inItems = [];
      (res.itemList || []).forEach(it => {
        const row = {
          ...it,
          skuId: it.skuId || it.productId,
          productId: it.productId,
          productName: it.productName || "",
          qty: it.qty,
        };
        if (it.direction === 2) {
          this.dataDetail.inItems.push(row);
        } else {
          this.dataDetail.outItems.push(row);
        }
      });
    },
    initNew() {
      this.dataDetail = {
        templateName: "", status: 1, remark: "",
        outItems: [{skuId: "", productId: "", productName: "", qty: 1}],
        inItems: [{skuId: "", productId: "", productName: "", qty: 1}],
      };
    },
    addOutItem() {
      this.$refs.outTable.toSelectMore();
    },
    addInItem() {
      this.$refs.inTable.toSelectMore();
    },
    deleteOutItem(index) {
      this.dataDetail.outItems.splice(index, 1);
      this.$refs.outTable.refresh();
    },
    deleteInItem(index) {
      this.dataDetail.inItems.splice(index, 1);
      this.$refs.inTable.refresh();
    },
    // 多选商品后回填 skuId/productId/productName
    addList2Out(list) {
      this.fillItem(this.dataDetail.outItems, list);
    },
    addList2In(list) {
      this.fillItem(this.dataDetail.inItems, list);
    },
    fillItem(items, list) {
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (items[i].skuId === list[j].id) {
            items[i].productId = list[j].parentId || list[j].id;
            items[i].productName = list[j].productName;
            items[i].qty = items[i].qty || 1;
          }
        }
      }
    },
    async saveData() {
      if (!this.dataDetail.templateName) {
        this.$message.error("请输入模板名称");
        return;
      }
      const outItems = (this.dataDetail.outItems || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        qty: it.qty,
        direction: 1,
      }));
      const inItems = (this.dataDetail.inItems || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        qty: it.qty,
        direction: 2,
      }));
      if (outItems.length === 0 || inItems.length === 0) {
        this.$message.error("出库与入库明细均不能为空");
        return;
      }
      const submitData = {...this.dataDetail, itemList: [...outItems, ...inItems]};
      await assemblyTemplateApi.save(submitData);
      this.router.push('/stock/makeUp/template');
    }
  }
};
</script>

<style lang="scss" scoped>
.make-up-template-detail {
  height: 100%;
  .list-table {
    padding: 10px;
  }
  .add-item-btn {
    border: 1.5px dashed var(--yq-border-color);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: var(--yq-font-color-tips);
    font-size: 13px;
    cursor: pointer;
    margin: 8px 16px;
    &:hover { color: var(--el-color-primary); border-color: var(--el-color-primary); }
  }
  .tip-info {
    font-size: 12px;
    color: var(--el-color-primary);
    background: var(--el-color-primary-light-9);
    padding: 8px 12px;
    border-radius: 4px;
    margin: 0 16px 10px;
  }
}
</style>
